// extracted by mini-css-extract-plugin
export default {"container":"uK-z","modal":"vK-z","dimensions":"wK-z","brandName":"xK-z","productName":"yK-z","labelValue":"zK-z","recipientEmail":"AK-z","recommendedFit":"BK-z","hiddenField":"CK-z"};